import { useMemberStore, useMetaStore } from '@/stores'
import { createRouter, createWebHistory } from 'vue-router'
import _ from 'lodash-es'
import Login from '@/pages/auth/Login.vue'
import Signup from '@/pages/auth/Signup.vue'
import MapPage from '@/pages/member/Map.vue'
import AdmMem from '@/pages/admin/member/AdmMem.vue'
import Root from '@/pages/Root.vue'
import { authPageType, get } from '@/common/util'
import SysConf from '@/pages/admin/config/SysConf.vue'
import ManServ from '@/pages/admin/config/ManServ.vue'
import MyPage from '@/pages/member/MyPage.vue'
import MemDetail from '@/pages/admin/MemDetail.vue'
import RoadViewInquery from '@/pages/member/RoadViewInquery.vue'
import OpenApi from '@/pages/member/OpenApi.vue'
import ManData from '@/pages/admin/data/ManData.vue'
import EditLayer from '@/pages/admin/data/EditLayer.vue'
import DataDetailPage from '@/pages/member/DataDetailPage.vue'
import EditStreetview from '@/pages/admin/data/EditStreetview.vue'
import StreetView from '@/components/member/StreetView.vue'
import ManMemo from '@/components/admin/data/ManMemo.vue'
import SvContainer from '@/pages/member/SvContainer.vue'
import SvNew from '@/pages/member/SvNew.vue'
import EditObjdetect from '@/pages/admin/data/EditObjdetect.vue'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes:[{path:'/login', component:Login}
    ,{path:'/signup', component:Signup}
    ,{path:'/member/map', component:MapPage}
    ,{path:'/member/mypage', component:MyPage}
    ,{path:'/member/rvinquery', component:RoadViewInquery}
    ,{path:'/member/openapi', component:OpenApi}
    ,{path:'/member/datadetail/:id/:type', component:DataDetailPage}
    ,{path:'/member/sv/:fid/:hlookat?/:vlookat?/:initmode?', component:StreetView}
    ,{path:'/member/svcon/:svid/:fid/:hlookat?/:vlookat?/:initmode?', component:SvContainer}
    ,{path:'/member/svnew/:svid/:fid/:bgmapid?', component:SvNew}

    ,{path:'/admin/manmem/:menu?', component:AdmMem}
    ,{path:'/admin/sysconf/:menu?', component:SysConf}
    ,{path:'/admin/manserv/:menu?', component:ManServ}
    ,{path:'/admin/memdetail/:mid', component:MemDetail}
    ,{path:'/admin/mandata/:menu?', component:ManData}
    ,{path:'/admin/editlayer/:id?', component:EditLayer}
    ,{path:'/admin/editsv/:id?', component:EditStreetview}
    ,{path:'/admin/editod/:id?', component:EditObjdetect}
    ,{path:'/admin/memo', component:ManMemo}

    ,{path:'/', component:Root}
    ,{path: "/:pathMatch(.*)*",redirect: "/"}
  ]
})
router.beforeEach((to, from, next)=>{
  const metaStore=useMetaStore()
  const memStore=useMemberStore()
  const authtype=authPageType(to.path)
  if(authtype=='noauth'){
    return next()
  }
  if(!memStore.isLoggedIn()){
    metaStore.toastKey('signinisrequired',false)
    return next('/login')
  }
  if(memStore.isLoggedIn()){
    if(authtype=='admin'&&!memStore.isAdm()){
      metaStore.toastKey('no_permission',false)
      return next('/')
    }else return next()
  }
  get('rest/public/checkloggedin',res=>{
    if(!res.isSuccess){
      memStore.reset()
      metaStore.toastKey('signinisrequired',false)
      return router.push('/login')
    }
  })
})
export default router
